// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type UserBalanceQueryVariables = Exact<{
  currency?: string | null | undefined;
}>;


export type UserBalanceQuery = { banking: { id: string, myBalances: { edges: Array<{ node: { id: string, currency: string | undefined, totalBalance: number | undefined, totalBonusBalance: number | undefined, bonusBalance: number | undefined, realBalance: number | undefined, lockedRealBalance: number | undefined, cashierBalance: number | undefined } | undefined } | undefined> | undefined } | undefined } | undefined };

export type BalanceFragment = { id: string, currency: string | undefined, totalBalance: number | undefined, totalBonusBalance: number | undefined, bonusBalance: number | undefined, realBalance: number | undefined, lockedRealBalance: number | undefined, cashierBalance: number | undefined };

export const BalanceFragmentDoc = gql`
    fragment BalanceFragment on BankingBalance {
  id
  currency
  totalBalance
  totalBonusBalance
  bonusBalance
  realBalance
  lockedRealBalance
  cashierBalance
}
    `;
export const UserBalanceQueryDocument = gql`
    query UserBalanceQuery($currency: String) {
  banking {
    id
    myBalances(walletCurrency: $currency, first: 1) {
      edges {
        node {
          ...BalanceFragment
        }
      }
    }
  }
}
    ${BalanceFragmentDoc}`;